import { BadgeCheck } from "lucide-react";

/**
 * Blue verified checkmark — superadmin-granted trust signal.
 * Use anywhere a user's name appears in public views.
 */
export default function VerifiedBadge({ size = 14, className = "", testid = "verified-badge" }) {
  return (
    <BadgeCheck
      size={size}
      strokeWidth={2}
      className={`inline-block ${className}`}
      style={{ color: "#1d9bf0", fill: "#1d9bf0", stroke: "white" }}
      data-testid={testid}
      aria-label="Verified"
    />
  );
}
